import A11yDialog from 'a11y-dialog'

import { DIALOG_INITIALISED_ATTR } from 'views/consts'
import { ARIA_HIDDEN } from 'views/assets/scripts/consts'

import toggleBoolStringAttribute from 'views/utils/toggleBoolStringAttribute'

const dialogs = new WeakMap()

const createA11Dialog = ({
  element,
  container = document.body,
  open = undefined
}: {
  element: HTMLElement
  container?: HTMLElement
  open?: Boolean
}): A11yDialog => {
  if (dialogs.has(element)) {
    return dialogs.get(element)
  }

  const a11dialog = new A11yDialog(element, container)
  dialogs.set(element, a11dialog)

  // Used for styling  - before this attribute visibility is controlled
  // by :target CSS selector
  element.setAttribute(DIALOG_INITIALISED_ATTR, 'true')

  a11dialog.dialog.addEventListener('click', (event: MouseEvent) => {
    // If those two are equal, it means that user clicked <dialog>
    // itself and not it’s contents. In practise that means that
    // backdrop was clicked.
    if (event.target === a11dialog.dialog) {
      a11dialog.hide()
    }
  })

  const isOpen = Boolean(open || a11dialog.dialog.hasAttribute('open'))
  toggleBoolStringAttribute(element, ARIA_HIDDEN, !isOpen)
  if (isOpen) {
    // SSR’d `<dialog open>` is in different state than one opened
    // with HTMLDialogElement.prototype.showModal() (focus is not
    // trapped and backdrop is missing).
    // To clean this up, we force it close and use A11YDialog’s method
    // to show it.

    // reset DOM state
    a11dialog.dialog.removeAttribute('open')
    // reset A11YDialog’s state
    a11dialog.shown = false

    a11dialog.show()
  }

  return a11dialog
}

export default createA11Dialog
